(function ($) {

'use strict';

	/**
	 * Load messi.min.css/messi.min.js and execute the optional callBackFunc
	 * when the script is loaded.
	 * @param {function} callBackFunc
	 * @return {Messi}
	 */
	$.initMessi = function (callBackFunc) {
		// load Messie if needed
		if (typeof Messi !== 'function') {
			// load messi notify 
			var cssFile = '/js/notify/messi.min.css';
			var jsFile = '/js/notify/messi.min.js?v2m';

			$('head').prepend('<link rel="stylesheet" href="' + cssFile + '">');
			$.cachedScript(jsFile).done(function () {
				console.log('common.js Messi - loaded');
				if (typeof callBackFunc === 'function') {
					return callBackFunc();
				}
			});
		} else if (typeof callBackFunc === 'function') {
			return callBackFunc();
		}
		return null;
	};	//$.initMessi

}(jQuery));